import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Cell } from 'react-sticky-table';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../lib/routing/frontend';
import { ccsdCodeCostSingleFetch } from '../../lib/redux/actions/ccsdCodeCosts';
import { ccsdCodeSingleFetch } from '../../lib/redux/actions/ccsdCodes';
import { isSeniorStaff } from '../../lib/helper/authorisation';
import { addToast } from '../../lib/redux/actions/toast';
import { defaultCcsdCodeCostSinglePatch } from '../../lib/redux/actions/defaultCcsdCodeCost';
import Alert from 'react-bootstrap/Alert';

const mapDispatchToProps = {
  defaultCcsdCodeCostSinglePatch,
  ccsdCodeCostSingleFetch,
  ccsdCodeSingleFetch,
  addToast,
};

class EditableCcsdCodeNote extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
      fieldValue: '',
    };
  }

  handleNoteChange(event) {
    this.setState(() => ({ fieldValue: event.target.value }));
  }

  startEditing() {
    if (!isSeniorStaff()) {
      return;
    }
    const { defaultCcsdCodeCost = false } = this.props;
    this.setState(() => ({ isEditing: true, fieldValue: defaultCcsdCodeCost ? defaultCcsdCodeCost.note ?? '' : '' }));
  }

  stopEditing(e) {
    e.stopPropagation();
    this.setState(() => ({ isEditing: false }));
  }

  saveAndStopEditing(e) {
    if (!isSeniorStaff()) {
      return;
    }

    const { ccsdCode, ccsdCodeCost = false, defaultCcsdCodeCost = false, addToast } = this.props;
    const existingNote = defaultCcsdCodeCost ? defaultCcsdCodeCost.note ?? '' : '';
    if (this.state.fieldValue === existingNote) {
      this.setState({ isEditing: false });
      return;
    }
    const data = {
      note: this.state.fieldValue,
    };

    if (defaultCcsdCodeCost !== false) {
      data['defaultCcsdCodeCost'] = defaultCcsdCodeCost['@id'];
    } else {
      data['ccsdCodeCost'] = ccsdCodeCost['@id'];
    }
    e.stopPropagation();
    this.props.defaultCcsdCodeCostSinglePatch(defaultCcsdCodeCost['@id'], data).then(() => {
      addToast('Note added successfully', true);
      this.setState({ isEditing: false });
      if (!ccsdCodeCost) {
        this.props.ccsdCodeSingleFetch(ccsdCode.id);
      } else {
        this.props.ccsdCodeCostSingleFetch(ccsdCodeCost.id);
      }
    });
  }

  renderContent() {
    const { healthInsurer, defaultCcsdCodeCost = false } = this.props;
    return this.state.isEditing ? (
      <div className={'d-flex flex-column '}>
        <span className={'pb-2'}><Link to={ROUTES.HEALTH_INSURERS.SINGLE.replace(':id', healthInsurer.id)}>{healthInsurer.name}</Link></span>
        <textarea className="form-control" name="note" id="note" value={this.state.fieldValue} onChange={this.handleNoteChange.bind(this)} />
        <div className={'text-right pb-2'}>
          <Button variant="primary" title="Save Note" size="sm" className="mb-0" onClick={this.saveAndStopEditing.bind(this)}>
            <i className="fas fa-check" />
          </Button>
          <Button variant="danger" title="Stop Editing" size="sm" className="mb-0" onClick={this.stopEditing.bind(this)}>
            <i className="fas fa-times" />
          </Button>
        </div>
      </div>
    ) : (
      <div>
        <p>
          <Link to={ROUTES.HEALTH_INSURERS.SINGLE.replace(':id', healthInsurer.id)}>{healthInsurer.name}</Link>
          {isSeniorStaff() && (
            <Button variant="link" title="Edit Note" size="sm" className="p-0 ml-2" onClick={this.startEditing.bind(this)}>
              <i className="fas fa-edit" />
            </Button>
          )}
        </p>
        {defaultCcsdCodeCost.note ? <Alert variant={'info'}>Note: {defaultCcsdCodeCost.note}</Alert> : null}
      </div>
    );
  }

  render() {
    const { isCell = false } = this.props;

//    let labelToUse = healthInsurer.name;
//    if (consultantHealthInsurer && consultantHealthInsurer.healthInsurer.canHaveOverrideLabel && consultantHealthInsurer.overrideLabel) {
//      labelToUse = consultantHealthInsurer.overrideLabel;
//    }
    return isCell ? (
      <Cell className="text-right border-right">
        {this.renderContent()}
      </Cell>
    ) : (
      <td>
        {this.renderContent()}
      </td>
    );
  }
}

export default connect(null, mapDispatchToProps)(EditableCcsdCodeNote);
